// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:48
import { AlarmStateChangeRequest_abstract } from './../../abstract/SagaBase/Defines/AlarmStateChangeRequest_abstract';
export class AlarmStateChangeRequest extends AlarmStateChangeRequest_abstract {}
